import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[roof-type-3]',
    templateUrl: './roof-type-3.component.html',
    styleUrl: './roof-type-3.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType3Component {
}
